import React from 'react';
import { useMutation } from 'hooks/apollo';
import { gql } from '@apollo/client';
import { SETTING_TYPES } from 'shared/constants/settings';
import DrawerForm from 'components/DrawerForm';
import removeEmptyValues from 'shared/utils/removeEmptyValues';
import SettingsList from './SettingsList';

const { ARRAY, PRICE } = SETTING_TYPES;

const UPDATE_SETTINGS_MUTATION = gql`
  mutation($input: SettingsInput!) {
    updateSettings(input: $input) {
      id
      key
      value
    }
  }
`;

const toSettingsInput = (values, settings) => Object.keys(values).map(key => {
  const { type } = settings[key];

  let value = values[key];

  if (value === '') {
    value = null;
  } else {
    if (type === ARRAY) {
      value = JSON.stringify(value.map(r => removeEmptyValues(r, v => v == null || v === '')));
    }

    if (type === PRICE) {
      value = JSON.stringify(removeEmptyValues(value, v => v == null || v === ''));
    }
  }

  return {
    key,
    value: value?.toString(),
  };
});

const SettingsDrawer = ({ title, settings = {}, relationId, initialValues, open, onSubmit, onCancel, onDone, children }) => {
  const [updateSettings] = useMutation(UPDATE_SETTINGS_MUTATION);

  const onFormSubmit = async (values) => {
    const { settings: updatedSettings, ...otherValues } = values;

    let id = relationId;

    if (onSubmit && otherValues) {
      id = await onSubmit(otherValues);
    }

    if (updatedSettings && id !== undefined) {
      await updateSettings({ variables: { input: { relationId: id, settings: toSettingsInput(updatedSettings, settings) } } });
    }
  };

  return (
    <DrawerForm title={title} open={open} onCancel={onCancel} onDone={onDone} onSubmit={onFormSubmit} initialValues={initialValues}>
      {children}
      <SettingsList settings={settings} relationId={relationId} edit onFormSubmit={onFormSubmit} />
    </DrawerForm>
  );
};

export default SettingsDrawer;
